var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          staticClass: "paper-dialog",
          attrs: {
            title: _vm.data ? "Update Content" : "New Content",
            visible: _vm.dialogVisible,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            close: _vm.onClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "padding-lr",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-width": "120px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "Category" } }, [
                _c(
                  "div",
                  { staticClass: "cate-select-add" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Please select content category",
                        },
                        model: {
                          value: _vm.form.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "categoryId", $$v)
                          },
                          expression: "form.categoryId",
                        },
                      },
                      _vm._l(_vm.categoryList, function (item, index) {
                        return _c(
                          "el-option",
                          {
                            key: index,
                            attrs: {
                              value: item.PaperCategoryID,
                              label: item.CategoryName,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "select-option-item",
                                attrs: { title: item.CategoryName },
                              },
                              [_vm._v(" " + _vm._s(item.CategoryName) + " ")]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                    _c("el-button", {
                      attrs: { icon: "el-icon-plus" },
                      on: { click: _vm.showCateDialog },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Security Level", prop: "levelID" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Please select security level" },
                      model: {
                        value: _vm.form.levelID,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "levelID", $$v)
                        },
                        expression: "form.levelID",
                      },
                    },
                    _vm._l(_vm.securityLevels, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.Name, value: item.Id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              !_vm.data
                ? _c(
                    "div",
                    { staticClass: "uploadFile" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "uploadFile",
                          attrs: { label: "Upload File", prop: "uploadFile" },
                        },
                        [
                          _c("MultipleFileUpload", {
                            ref: "fileUpload",
                            attrs: {
                              action: "/quickPush/uploadFile",
                              accept: ".PDF,.pdf,.docx,doc,.ppt,.pptx",
                              message:
                                "Only PDF, Doc and PPT file can be uploaded",
                            },
                            on: {
                              success: _vm.handleSuccess,
                              fail: _vm.handleFail,
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "upload-files" },
                            _vm._l(_vm.files, function (file, i) {
                              return _c(
                                "div",
                                { key: i, staticClass: "upload-file-item" },
                                [
                                  _c("div", { staticClass: "file-info" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: file.previewUrl,
                                          target: "_blank",
                                          title: file.originalName,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-document",
                                        }),
                                        _vm._v(
                                          " " + _vm._s(file.originalName) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteFile(i)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-close",
                                        }),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "file-description" },
                                    [
                                      _c("label", [_vm._v("Description")]),
                                      _c("el-input", {
                                        staticClass: "description-input",
                                        attrs: {
                                          type: "textarea",
                                          rows: 2,
                                          placeholder: "Please input...",
                                          maxlength: "500",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.uploadFiles[i].description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.uploadFiles[i],
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "uploadFiles[i].description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "uploadFile" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "uploadFile",
                          attrs: { label: "Description" },
                        },
                        [
                          _c("div", { staticClass: "upload-files" }, [
                            _c("div", { staticClass: "upload-file-item" }, [
                              _c(
                                "div",
                                { staticClass: "file-description" },
                                [
                                  _c("label", [_vm._v("Description")]),
                                  _c("el-input", {
                                    staticClass: "description-input",
                                    attrs: {
                                      type: "textarea",
                                      rows: 3,
                                      placeholder: "Please input...",
                                      maxlength: "500",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.fileDescription,
                                      callback: function ($$v) {
                                        _vm.fileDescription = $$v
                                      },
                                      expression: "fileDescription",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "push-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(" Submit ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("NewCategoryDialog", {
        attrs: { visible: _vm.addCategoryDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.addCategoryDialogVisible = $event
          },
          success: _vm.onNewCateSuccess,
          closed: _vm.onNewCateClosed,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }